import { ReactPlugin } from "@microsoft/applicationinsights-react-js"
import { ApplicationInsights } from "@microsoft/applicationinsights-web"

const connectionString: string = process.env.REACT_APP_AZURE_APP_INSIGHTS_CONNECTION_STRING ?? ""

const reactPlugin = new ReactPlugin()
export const applicationInsights = new ApplicationInsights({
  config: {
    connectionString,
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    autoTrackPageVisitTime: true,
  },
})
